import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock } from "lucide-react";
import { useAdminAuth } from "@/admin/AdminAuth";

function formatDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : "")).filter(Boolean).join(" ");
  return String(detail);
}

export default function AdminLogin() {
  const { login } = useAdminAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email.trim(), password);
      toast.success("Welcome back.");
      navigate("/admin");
    } catch (err) {
      toast.error(formatDetail(err?.response?.data?.detail) || "Login failed.");
    } finally {
      setLoading(false);
    }
  };

  const inputCls =
    "w-full border-b border-dh-cream/20 bg-transparent px-1 py-3 font-body text-base text-dh-cream placeholder:text-dh-muted/70 outline-none transition-colors duration-300 focus:border-dh-gold";

  return (
    <div className="flex min-h-screen items-center justify-center bg-dh-bg px-5">
      <div className="w-full max-w-sm">
        <div className="mb-8 flex items-center gap-3 text-dh-gold">
          <Lock size={18} />
          <p className="font-body text-[11px] uppercase tracking-ultra">Private · Dhamma Admin</p>
        </div>
        <h1 className="font-display text-4xl text-dh-cream">Sign In</h1>
        <form onSubmit={submit} data-testid="admin-login-form" className="mt-10 space-y-7" noValidate>
          <div>
            <label htmlFor="a-email" className="mb-2 block font-body text-[11px] uppercase tracking-[0.2em] text-dh-muted">
              Email
            </label>
            <input id="a-email" data-testid="admin-email" type="email" autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} placeholder="admin@dhammapublishinghouse.com" />
          </div>
          <div>
            <label htmlFor="a-password" className="mb-2 block font-body text-[11px] uppercase tracking-[0.2em] text-dh-muted">
              Password
            </label>
            <input id="a-password" data-testid="admin-password" type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls} placeholder="••••••••" />
          </div>
          <button
            type="submit"
            data-testid="admin-login-submit"
            disabled={loading}
            className="mt-2 w-full border border-dh-gold/70 bg-transparent px-8 py-4 font-body text-[11px] uppercase tracking-[0.22em] text-dh-gold transition-[background-color,color] duration-500 hover:bg-dh-gold hover:text-dh-bg2 disabled:opacity-50"
          >
            {loading ? "Signing in…" : "Enter"}
          </button>
        </form>
      </div>
    </div>
  );
}
